<template>
    <section v-if="isshow" class="news" v-animate="'fade-in'">
        <div class="section-container">
            <div class="container">
                <h2 class="sub_title text-center">ニュース</h2>
                <div class="row news-items mt-5 d-flex justify-content-center">
                    <NewsItem v-for="post in posts" :key="post.id"
                                :category="post.categories" :content="post.title"  :href="post.link+'?id='+post.id" v-animate="'slide-in-up'"/>
                </div>
                <div class="d-flex justify-content-center">
                    <a class="btn mt-5 button btn-dark-border hover_bg_label" href="/global/news/">
                        <span class="hover_bg_label_text">View all</span>
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import NewsItem from "./NewsItem";
export default {
    name: 'News',
    components: { NewsItem },
    props: {
        category: String
    },
    data () {
        return {
            isshow: true,
            posts: []
        }
    },
    created() {
        this.axios.get('/global-news/news.json').then( res => {
            for(let i=0; i<res.data.length; i++) {
                if(res.data[i].categories.includes(this.category) 
                && this.posts.length < 3) {
                    this.posts.push(res.data[i])
                }
            }
            if(this.posts.length == 0) {this.isshow = false}
        })
    }
}
</script>

<style scoped>
    .news {
        background-color: #f8f8f8;
        padding: 108px 0 100px 0;
    }
    .news-items {
        max-width: 1088px;
        margin: 0 auto;
    }

    .sub_title {
        margin-bottom: 56px;
    }

    @media screen and (max-width: 1000px) {
        .news-items {
            max-width: 879px;
        }
    }

    @media screen and (max-width: 767px) {
        .news {
            padding: 74px 0 80px 0;
        }
    }

    @media screen and (max-width: 600px) {
        .news-items {
            max-width: 479px;
        }
    }
</style>
